import readXlsxFile from 'read-excel-file';

function getColumnFromIndex(value) {
	var base = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
	value++;
	var remainder, result = "";
	do {
		remainder = value % 26;
		result = base[(remainder || 26) - 1] + result;
		value = Math.floor(value / 26);
	} while (value > 0);
	return result;
}

function readColumns(blob) {
	return readXlsxFile(blob)
		.then((rows) => {
			const blankExcelRow = rows.find(r => r.every(c => c === null));

			if (!blankExcelRow) {
				return (rows.find(r => r.some(c => c != null)) || []).map((f, i) => f || `${this.$tCaption('Column')} ${i + 1} (${this.getColumnFromIndex(i)})`);
			}

			return [];
		});
}

function getUsedColumnsInSsml(ssml, columns) {
	columns = columns || [];

	const excludedColumns = ['Target_Lat', 'Target_Lon', 'Target_Name'];
	
	let usedColumns = [...(ssml.match(/\[(.*?)\]/g) || [])].map(f => f && f.replace(/[\[\]]/g, '').replace('@xls', '')).filter(f => f);
	usedColumns.map(f => {
		if (!columns.includes(f) && !excludedColumns.includes(f)) {
			columns.push(f);
		}
	});

	return columns;
}

export default {
	getColumnFromIndex,
	readColumns,
	getUsedColumnsInSsml
}

export {
	getColumnFromIndex,
	readColumns,
	getUsedColumnsInSsml
}
